import config from './config.json'

const Twirp_Prefix = config.urlapi+"/twirp/kpsn.KPSN"
const Const = {
    API_Register : config.urlapi+"/api/register",
    API_UpdateProfile : config.urlapi+"/api/update/",
    API_DeleteProfile : config.urlapi+"/api/delete/",
    API_Login_URL : Twirp_Prefix + "/Login",
    API_Logout_URL : Twirp_Prefix + "/Logout",
    API_ListCountries : Twirp_Prefix + "/ListCountries",
    API_ListStates : Twirp_Prefix + "/ListStateCountry",
    API_ListCities : Twirp_Prefix + "/ListCityState",
    API_ListDistrict : Twirp_Prefix + "/ListCabangCity",
    API_ListRanting : Twirp_Prefix + "/ListRantingCabang",
    API_ReadCountry : Twirp_Prefix + "/ReadCountry",
    API_CreateCountry : Twirp_Prefix + "/CreateCountry",
    API_UpdateCountry : Twirp_Prefix + "/UpdateCountry",
    API_DeleteCountry : Twirp_Prefix + "/DeleteCountry",
    API_ReadState : Twirp_Prefix + "/ReadState",
    API_CreateState : Twirp_Prefix + "/CreateState",
    API_UpdateState : Twirp_Prefix + "/UpdateState",
    API_DeleteState : Twirp_Prefix + "/DeleteState",
    API_ReadCity : Twirp_Prefix + "/ReadCity",
    API_CreateCity : Twirp_Prefix + "/CreateCity",
    API_UpdateCity : Twirp_Prefix + "/UpdateCity",
    API_DeleteCity : Twirp_Prefix + "/DeleteCity",
    API_ReadCabang : Twirp_Prefix + "/ReadCabang",
    API_CreateCabang : Twirp_Prefix + "/CreateCabang",
    API_UpdateCabang : Twirp_Prefix + "/UpdateCabang",
    API_DeleteCabang : Twirp_Prefix + "/DeleteCabang",
    API_ReadRanting : Twirp_Prefix + "/ReadRanting",
    API_CreateRanting : Twirp_Prefix + "/CreateRanting",
    API_UpdateRanting : Twirp_Prefix + "/UpdateRanting",
    API_DeleteRanting : Twirp_Prefix + "/DeleteRanting",
    API_ListCountryStats : Twirp_Prefix + "/ListOrgStats",
    API_ListMedalStats : Twirp_Prefix + "/ListMedalStats",
    API_ReadPesilat : Twirp_Prefix + "/ReadPesilat",
    API_ListPesilatPaginated : Twirp_Prefix + "/ListPesilatPaginated",
    API_ListPesilatRanting : Twirp_Prefix + "/ListPesilatRanting",
    API_SearchPesilat : Twirp_Prefix + "/SearchPesilat",
    API_ReadPrestasi : Twirp_Prefix + "/ReadPrestasi", 
    API_RantingTree : Twirp_Prefix + "/ListRantingTree", 
    API_ListRantingPesilat : Twirp_Prefix + "/ListRantingPesilat", 
    API_ContactUs : Twirp_Prefix + "/ContactUs", 
    Captcha_New : config.urlapi+"/captcha/new",
    Captcha_Download : config.urlapi+"/captcha/download/",
    File_Download : config.urlapi+"/file/download/",

}
export default Const